import React, { Component } from "react";
import { Carousel, CarouselControl, CarouselItem, Button } from "reactstrap";
import { connect } from "react-redux";
import { BaseUrl } from "../../BaseUrl/BaseUrl";

@connect((state) => ({
  auth: state.apa,
}))
export class Presentation extends Component {
  state = {
    activeIndex: 0,
    animating: false,
    fullscreen: false,
  };

  componentDidMount() {
    if (this.props.updateCurrentSlide) {
      if (this.props.user && this.props.auth.user.access_code) {
        this.setState({
          activeIndex: this.props.auth.user.access_code.current_slide || 0,
        });
      }
    }
  }

  render() {
    const { items, endPresentation } = this.props;
    const { activeIndex, animating, fullscreen } = this.state;

    const updateCurrentPage = (currentSlide) => {
      if (!this.props.updateCurrentSlide) return;
      const headers = {
        Authorization: `Token ${this.props.auth.token}`,
        "Content-Type": "application/json",
      };
      const body = JSON.stringify({
        current_slide: currentSlide,
      });
      fetch(`${BaseUrl}/api/auth/user/update/`, {
        headers,
        method: "POST",
        body,
      });
    };

    const setActiveIndex = (activeIndex) => {
      this.setState(
        {
          activeIndex: activeIndex,
        },
        () => updateCurrentPage(activeIndex)
      );
    };

    const setAnimating = (animating) => {
      this.setState({
        animating: animating,
      });
    };

    const goFirst = () => {
      setActiveIndex(0);
    };
    const goLast = () => {
      setActiveIndex(items.length - 1);
      endPresentation();
    };

    const next = () => {
      if (animating) return;
      if (activeIndex === items.length - 1) return;
      const nextIndex = activeIndex + 1;
      setActiveIndex(nextIndex);
      if (nextIndex === items.length - 1) {
        endPresentation();
      }
    };

    const previous = () => {
      if (animating) return;
      if (activeIndex === 0) return;
      const nextIndex = activeIndex - 1;
      setActiveIndex(nextIndex);
    };

    const toggleFullscreen = () => {
      const handleFullscreenChange = () => {
        const isFullscreen = Boolean(document.fullscreenElement);
        this.setState({
          fullscreen: isFullscreen,
        });
      };

      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        this.setState({
          fullscreen: true,
        });
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          document.removeEventListener(
            "fullscreenchange",
            handleFullscreenChange
          );
          this.setState({
            fullscreen: false,
          });
        }
      }

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          if (document.fullscreenElement) {
            document.exitFullscreen();
            document.removeEventListener(
              "fullscreenchange",
              handleFullscreenChange
            );
            this.setState({
              fullscreen: false,
            });
          }
        }
      });
    };

    const slides = items.map((item) => {
      return (
        <CarouselItem
          onExiting={() => setAnimating(true)}
          onExited={() => setAnimating(false)}
          key={item}>
          <img
            style={{ margin: "auto", display: "block" }}
            src={item}
            alt={item}
            width={fullscreen ? "69% " : 600}
          />
        </CarouselItem>
      );
    });

    return (
      <div
        style={{
          position: fullscreen ? "fixed" : "relative",
          left: fullscreen && 0,
          top: fullscreen && 0,
          bottom: fullscreen && 0,
          right: fullscreen && 0,
          backgroundColor: fullscreen && "#dfdfdf",
          zIndex: fullscreen && 999,
          overflow: "auto",
        }}>

        <Carousel
          interval={false}
          activeIndex={activeIndex}
          next={next}
          previous={previous}>
          {slides}

          <CarouselControl
            direction="prev"
            directionText="Previous"
            onClickHandler={previous}
          />
          <CarouselControl
            direction="next"
            directionText="Next"
            onClickHandler={next}
          />
        </Carousel>

        <br />

        {!fullscreen && (
          <div className="pr-4 pl-4 text-right">
            <Button onClick={toggleFullscreen} color="primary">
            <i className="fas fa-expand"></i>
            </Button>
          </div>
        )
        }


        <p
          className={
            fullscreen ? "pl-4 pr-4 text-left" : "pr-4 pl-4 text-right"
          }>
          Seite {activeIndex + 1} von {slides.length} /
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              goFirst();
            }}>
            {" "}
            Zum Anfang
          </a>{" "}
          /
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              goLast();
            }}>
            {" "}
            Zum Ende
          </a>
          {fullscreen && (
            <Button
              onClick={toggleFullscreen}
              className="float-right btn btn-danger">
              <i className="fa fa-window-close" aria-hidden="true"></i>
            </Button>
          )}
        </p>
      </div>
    );
  }
}
